import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Add from '../../component/Banner/AddBanner'
import constant from '../../constant'
import { bannerById, updateBanner } from '../../actions/utilitiesAction'

const AddSkills = () => {

    const [response, setResponse] = useState({})
    const [showMsg, setShowMsg] = useState(false)
    const navigate = useNavigate()
    const params = useParams()
    const [data, setData] = useState(null)

    useEffect(() => {
        bannerById(params.id).then((res) => {
            if (res.status) {
                setData(res.result)
            } else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch(err => {
            alert(err)
        })
    }, [])

    const onSubmit = (model) => {
        updateBanner(model).then((res) => {
            if (res.status) {
                navigate(constant.component.bannerlist.url)
            } else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    return (
        <React.Fragment>
            {data && <Add
                onSubmit={onSubmit}
                detail={data}
                response={response}
                showMsg={showMsg}
                title="Update Banner" />}
        </React.Fragment>
    )
}

export default AddSkills